import { action } from 'mobx';
import { Observer } from 'mobx-react-lite';
import React from 'react';
import { runAndIgnoreError } from '../../utils/errors.utils';
import { useProps, useStore } from '../../utils/mobx.utils';
import { isObject, isString } from '../../utils/typeChecks.utils';
import ErrorList from './ErrorList';
import './ErrorRenderer.scss';
var defaultMessage = 'An unknown error occurred.';
var ErrorRenderer = function (props) {
    var p = useProps(props);
    var s = useStore(function () { return ({
        errorMessage: defaultMessage,
        details: {},
        get originalError() {
            return p.error || p.e;
        },
        get errorDetails() {
            return s.originalError instanceof Object ? 'response' in s.originalError ? s.originalError.response : s.originalError : s.originalError;
        },
        get shouldRenderDetails() {
            return Object.keys(s.details).length > 0;
        }
    }); });
    runAndIgnoreError(action(function () {
        var _a, _b, _c, _d, _e;
        var e = (isObject(s.errorDetails) && ((_a = s.errorDetails) === null || _a === void 0 ? void 0 : _a.data) ? (_b = s.errorDetails) === null || _b === void 0 ? void 0 : _b.data : s.errorDetails);
        s.errorMessage = (_e = (_c = (isString(e) ? e : ((e === null || e === void 0 ? void 0 : e.message) || (e === null || e === void 0 ? void 0 : e.error)))) !== null && _c !== void 0 ? _c : (_d = s.originalError) === null || _d === void 0 ? void 0 : _d.message) !== null && _e !== void 0 ? _e : 'Unknown Error';
        if (isObject(e) && 'errors' in e) {
            Object.assign(s.details, e === null || e === void 0 ? void 0 : e.errors);
        }
    }));
    return React.createElement(Observer, { children: function () { return (React.createElement("div", { className: "ErrorRenderer" },
            React.createElement("p", null, s.errorMessage),
            s.shouldRenderDetails && React.createElement(ErrorList, { errors: s.details }))); } });
};
export default ErrorRenderer;
